import { itemCategoryActionSelectors } from "../Selectors/index";

const initValue = {
  loading: false,
  rows: [],
};

export const itemCategoryReducer = (state = initValue, { type, payload }) => {
  switch (type) {
    case itemCategoryActionSelectors.GET_ITEM_CATEGORY:
      return {
        ...state,
        loading: true,
      };
    case itemCategoryActionSelectors.GET_ITEM_CATEGORY_SUCCESS:
      return {
        loading: false,
        rows: payload,
      };

    default:
      return state;
  }
};
